import { render, staticRenderFns } from "./Especificacoes.vue?vue&type=template&id=fd675134&scoped=true&"
import script from "./Especificacoes.vue?vue&type=script&lang=js&"
export * from "./Especificacoes.vue?vue&type=script&lang=js&"
import style0 from "./Especificacoes.vue?vue&type=style&index=0&id=fd675134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd675134",
  null
  
)

export default component.exports